var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7F1FE18F-B621-42B5-9A86-8D2AA22BF4C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reviews",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case_study_no_nav",
    transform: "translate(-271.000000, -672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Review-2",
    transform: "translate(269.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumb_down-24px",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 17.0744526 0 17.0744526 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6715328,2.25 L4.26861314,2.25 C3.67812165,2.25 3.17300243,2.625 2.95957178,3.165 L0.811036496,8.4525 C0.747007299,8.625 0.711435523,8.805 0.711435523,9 L0.711435523,10.5 C0.711435523,11.325 1.35172749,12 2.13430657,12 L6.62346472,12 L5.94760097,15.4275 L5.92625791,15.6675 C5.92625791,15.975 6.04720195,16.26 6.23928954,16.4625 L6.99341119,17.25 L11.6817713,12.3075 C11.9378881,12.0375 12.0944039,11.6625 12.0944039,11.25 L12.0944039,3.75 C12.0944039,2.925 11.4541119,2.25 10.6715328,2.25 Z M13.5172749,2.25 L13.5172749,11.25 L16.363017,11.25 L16.363017,2.25 L13.5172749,2.25 Z",
    id: "Shape",
    fill: "#5B7186"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.9873c9ddbfcb45cda0d22bdc1386c32c.svg";
export { ForwardRef as ReactComponent };